import {Component, Input} from '@angular/core';
import {Message} from '../../../contracts/message.interface';

@Component({
  standalone: true,
  selector: 'app-message-audio',
  imports: [],
  templateUrl: './message-audio.component.html',
  styleUrl: './message-audio.component.scss'
})
export class MessageAudioComponent {
  @Input() message!: Message;
}
